import { useContext } from "react";
import { AppContext } from "../App";
import ProductCatalogLanding from "../views/ProductCatalogLanding";
import ProductsLanding from "../views/ProductsLanding";

export default function Products(props) {
  const appContext = useContext(AppContext);

  if (
    !appContext.navSubItem &&
    !appContext.navExtraItem &&
    !appContext.navMoreItem
  ) {
    return <ProductsLanding />;
  }

  if (
    appContext.navSubItem === "catalog" &&
    appContext.navExtraItem &&
    !appContext.navMoreItem
  ) {
    return <ProductCatalogLanding uuid={appContext.navExtraItem} />;
  }

  return null;
}
